import React, { Component } from "react";

import QAErrorList from "./QAErrorList";


import { withStyles } from '@material-ui/core/styles';
//import { makeStyles, withStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import ArrowLeftIcon from '@material-ui/icons/ArrowLeft';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Tooltip from '@material-ui/core/Tooltip';
import Button from '@material-ui/core/Button';

class QAErrorFullList extends Component {
	constructor(props) {
        super(props);
		this.state= {
			dialogOpen: false
		}
		this.handleOpen = this.handleOpen.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.handleClick = this.handleClick.bind(this);
    }
	
	handleOpen(){
		this.setState({dialogOpen: true});
	};
	
	handleClose(){
		this.setState({dialogOpen: false});
	};
	
	handleClick(id){

	}
	
	render() {
		return (
			<span>
			<Dialog open={this.state.dialogOpen} onClose={this.handleClose} fullWidth={true} maxWidth = {'md'}>
				<DialogTitle>QA List</DialogTitle>
				<DialogContent dividers>
					<DialogContentText>
						<QAErrorList errors={this.props.errors}
									goToSegment={this.props.goToSegment}/>
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={this.handleClose} color="primary">
					CLOSE
					</Button>
				</DialogActions>
			</Dialog>
			
			<Tooltip title="View full text"><FormatListBulletedIcon className="actionIcon" onClick={() => { this.handleOpen(); }}/></Tooltip>
		</span>
		);
  }
};

export default (QAErrorFullList);